module.exports = __webpack_public_path__ + "img/logo.b7c38e6c.png";